const CTAButton = ( CTA ) => {
const {ctaButton} = CTA;
  return (
    <div className={`section__CTA_Button ${ctaButton.buttonType}`}>
      <a className="button" target={ctaButton.newTab === "yes" ? "_blank" : "_self"} href={ctaButton?.buttonLink}>
        {ctaButton?.buttonText}
      </a>
  </div>
  );
};

export default CTAButton;
